import classNames from 'classnames';
import React from 'react';

import styles from './index.scss';

/**
 * Styled label component
 */
export default function Label({
  children,
  className,
  htmlFor,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
}) {
  return (
    <label
      className={classNames(styles.Label, className)}
      htmlFor={htmlFor}
      {...props}
    >
      {children}
    </label>
  );
}
